<template>
  <div id="app">
    <notifications
      group="error"
      classes="errorNotification"
      position="bottom right"
      :max="3"
    />
    <notifications
      group="success"
      classes="successNotification"
      position="bottom right"
      :max="3"
    />
    <app-header v-if="isLogged && currentRoute !== '/login'"></app-header>
    <AppAlert class="pt-0" />
    <app-page></app-page>
    <app-footer v-if="isLogged && currentRoute !== '/login'"></app-footer>
  </div>
</template>
<script>
import Footer from "./Footer";
import Header from "./Header";
import Page from "./Page";
import AppAlert from "../components/AppAlert";
import { events } from "../websockets";
export default {
  sockets: events,

  data() {
    return {
      currentRoute: "",
      notificationsInterval: null,
    };
  },
  watch: {
    $route() {
      this.currentRoute = this.$route.path;
    },
    isLogged(val) {
      // Pobierz rolę rozliczeniową także po zalogowaniu bez przeładowania strony
      // (mounted odpala się tylko raz przy starcie aplikacji).
      if (val) {
        this.$store.dispatch("fetchMyPanelRole");
      }
    },
  },
  components: {
    appFooter: Footer,
    appHeader: Header,
    appPage: Page,
    AppAlert,
  },

  computed: {
    isLogged() {
      return this.$store.getters.getToken;
    },
  },

  mounted() {
    window.sessionStorage.removeItem("dodLastRoute");
    this.notificationsInterval = setInterval(() => {
      this.$store.dispatch("fetchDodAdminNotifications");
    }, 10000);
    if (this.isLogged) {
      this.$store.dispatch("fetchMyPanelRole");
    }
  },
  destroyed() {
    clearInterval(this.notificationsInterval);
  },
};
</script>
<style>
:root {
  /* Navbar height (.navbar in Header.vue) - offset for sticky elements in the
     content so they don't slide under the pinned header. */
  --app-header-height: 6rem;
}
html {
  overflow: -moz-scrollbars-vertical;
  overflow-y: scroll;
  font-size: 11px !important;
}
html body {
  font-family: "Poppins", sans-serif;
  padding-right: 0 !important;
}
#app {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #f2f3f7;
}
body {
  /* change app background */
  /* background: #f2f2f2; */
  background: #ffffff;
}
.flex {
  display: flex;
}
thead {
  background: linear-gradient(
    36.47deg,
    rgb(251, 137, 40) 10.51%,
    #e50582 109.44%
  ) !important;
  color: white;
  height: 5rem !important;
  /* background: rgba(243, 129, 43, 0.5) !important; */
  font-weight: 600 !important;
  padding: 0;
  vertical-align: middle !important;
}
th {
  vertical-align: middle !important;
  min-width: 60px;
  text-align: left !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
td {
  vertical-align: middle !important;
  max-width: 250px;
  text-align: left !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
td div {
  padding-right: 0 !important ;
  padding-left: 0 !important ;
}
td div,
td button {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
table tr th:first-child {
  border-radius: 0 0px 0px 0px;
  overflow: hidden;
}
table tr th:last-child {
  overflow: hidden;
}
table tr:last-child td:last-child {
  overflow: hidden;
}
table tr:last-child td:first-child {
  border-radius: 0px 0px 0px 0px;
  overflow: hidden;
}

table {
  background-color: white;
  margin: 0;
  padding: 0;
  margin-bottom: 50px !important;
}
thead {
  overflow: hidden;
}
.borderless td,
.borderless th,
.borderless thead th,
table {
  border: none;
}
table tbody tr:not(:last-child) {
  border-bottom: 1px solid grey;
}
table,
th,
td {
  border-collapse: collapse;
  text-align: center;
  font-family: "Poppins", sans-serif;
}
.notFoundListAlert {
  text-align: center;
  color: #721c24 !important;
  background-color: rgba(248, 215, 218, 0.6) !important;
  border-color: #f5c6cb !important;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.table td.fit,
.table th.fit {
  white-space: nowrap !important;
}
.successNotification {
  background: #68cd86 !important;
  border-left-color: #42a85f !important;
  border-radius: 10px;
  border: 5px solid #42a85f !important;
  border: 1px solid;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 10px;
  min-width: 300px;
  z-index: 1000;
}
.errorNotification {
  background: #e54d42 !important;
  border-left-color: #b82e24 !important;
  border: 5px solid #b82e24 !important;
  border-radius: 10px;
  color: white !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 10px;
  min-width: 300px;
  z-index: 1000;
}
h1 {
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  margin-bottom: 20px;
}
h2 {
  font-family: "Poppins", sans-serif;
  text-align: center;
  font-size: 18px;
  margin-top: 20px;
  padding: 2px;
  color: #090741;
}
h5 {
  text-align: center;
  color: #090741;
}
h6,
h4 {
  color: #090741;
}
button {
  padding-bottom: 4px !important;
  padding-top: 4px !important;
}

.loader {
  visibility: hidden;
  border: 2px dashed #090741;
  margin-left: 20px;
}
.visibleLoader {
  visibility: visible;
}

.googleMap img {
  max-width: 100% !important;
  max-height: 100% !important;
}
.googleMap div {
  padding: 0 !important;
}
.padding-zero {
  padding: 0 !important;
}
.img-avatar {
  height: 40px;
  width: 40px;
  border-radius: 80%;
}
.addNewButton {
  background: #090741;
  border-color: #090741;
  color: white;
  width: 100%;
  font-weight: bold;
}
.addNewButton:hover {
  background: rgb(251, 137, 40) 10.51%;
  border-color: #fb8928;
  outline: #fb8928;
}

button:focus {
  outline: 0 solid #090741 !important;
}

.form-control:focus,
.datepickers input:focus {
  color: #495057;
  background-color: rgb(251, 137, 40) 10.51%;
  border-color: #fb8928;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(229 5 130 / 25%);
}
.btn-outline-light {
  color: #090741 !important;
  font-size: 10px !important;
  margin: 4px 4px;
  background: rgba(9, 7, 65, 0.05) !important;
  padding: 2px 8px;
}
.btn-outline-dark {
  background: #090741 !important;
  color: white;
  font-size: 10px !important;
  margin: 4px 4px;
  border: none;
  padding: 2px 8px;
}
.btn-outline-danger {
  background: #fc0606 !important;
  color: white;
  font-size: 10px !important;
  margin: 4px 4px;
  border: none;
  padding: 2px 8px;
}

.btn-outline-yellow {
  background: #fcc111 !important;
  color: white;
  font-size: 10px !important;
  margin: 4px 4px;
  border: none;
  padding: 2px 8px;
}
.btn-outline-gradient {
  background: linear-gradient(90deg, #fb8928 0%, #e50582 100%);
  border-radius: 24px;
  color: white;
  margin: 4px 4px;
  border: none;
  font-size: 10px !important;
  padding: 2px 8px;
}
.btn-outline-dark:hover,
.btn-outline-light:hover {
  background: #fb8928 !important;
  color: white;
  font-size: 10px !important;
  margin: 4px 4px;
  transition-duration: 0.3s;
  padding: 2px 8px;
}
div {
  padding: 5px;
}

.datepickers {
  display: flex;
  gap: 1rem;
}
.datepickers input {
  border: 1px solid #ced4da;
  border-radius: 10px;
  padding: 10px;
  height: 20px !important;
  background: #f2f2f2;
  margin-left: -10px;
}
.datepickers input:focus {
  outline: none;
}
.datepickers {
  position: relative;
}
.vue-swatches__container {
  background: none !important;
}
.serviceRegulation {
  border: 1px solid grey;
  padding: 0.5rem;
  font-size: 9px;
  border-radius: 10px;
  width: 100%;
}
.ql-container {
  background: #fff;
}
.save-button {
  margin-top: 4rem;
  min-width: 320px;
  font-size: 15px !important;
  background: rgb(8, 130, 8) !important;
  margin: 4rem 0 !important;
  width: 100%;
}
.save-button:hover {
  background: rgb(9, 95, 9) !important;
  color: white;
  font-size: 15px !important;
}
.app-modal {
  border-radius: 5px;
  background: #f7f7f7;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
.vdp-datepicker button,
.vdp-datepicker input {
  width: 140px;
  padding: 5px;
  cursor: pointer;
}

.text-pink {
  color: #e2037e;
}
.dod-container {
  margin: 0 2rem !important;
  width: 100%;
}
.bigger-input {
  width: 35%;
  min-width: 250px;
  height: fit-content;
}
.medium-input {
  width: 30%;
  min-width: 200px;
  height: fit-content;
}
.small-input {
  width: 15%;
  min-width: 120px;
  height: fit-content;
}
.special-char {
  color: #ec1a6b;
}
.custom-error-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding: 0;
}
.custom-error-msg {
  display: block;
  width: 100%;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: red;
  color: white;
  font-size: 14px;
  margin-top: 5px;
  position: absolute;
}
.loading-container {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.seniorapp-label {
  color: #e2037e;
}
.cursor-pointer {
  cursor: pointer;
}

.ql-mention-list-container {
  min-width: 150px;
  max-height: 550px;
  background: #ffffff;
  border-radius: 5px;
  margin: 0;
  padding: 0;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.75);
  z-index: 100000;
  overflow-y: auto;
}
.ql-mention-list-container ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.ql-mention-list-item {
  padding: 0.75rem;
  list-style: none;
}
.ql-mention-list-item:nth-child(odd) {
  background: rgba(226, 3, 126, 0.07);
}
.ql-mention-list-item:hover,
.ql-mention-list .selected {
  background: #e2037e;
  color: white;
  cursor: pointer;
}
.color-background {
  background: rgba(226, 3, 126, 0.07);
}
</style>
